function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 330 330",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M41,21L41,248L94,249L94,312L293,311L293,78L236,78L234,23L41,21Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,270L80,270L80,315C80,323.284 86.716,330 95,330L295,330C303.284,330 310,323.284 310,315L310,75C310,66.716 303.284,60 295,60L250,60L250,15C250,6.716 243.284,0 235,0L35,0C26.716,0 20,6.716 20,15L20,255C20,263.284 26.716,270 35,270ZM280,300L110,300L110,90L280,90L280,300ZM50,30L220,30L220,60L95,60C86.716,60 80,66.716 80,75L80,240L50,240L50,30Z",
    style: {
      fill: "rgb(230,25,105)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,120C146.716,120 140,126.716 140,135C140,143.284 146.716,150 155,150L235,150C243.284,150 250,143.284 250,135C250,126.716 243.284,120 235,120L155,120ZM235,180L155,180C146.716,180 140,186.716 140,195C140,203.284 146.716,210 155,210L235,210C243.284,210 250,203.284 250,195C250,186.716 243.284,180 235,180ZM235,240L155,240C146.716,240 140,246.716 140,255C140,263.284 146.716,270 155,270L235,270C243.284,270 250,263.284 250,255C250,246.716 243.284,240 235,240Z",
    style: {
      fill: "rgb(230,25,105)",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.e97c0964f5cb875f92e9db23d5d72c8f.svg";
export { ForwardRef as ReactComponent };